import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import apis from '@/pages/activity-manage/merchants/create-merchants/apis';

const { Option } = Select;

function SelectActivityLevel({ version = 0, planCode, ...props }) {
  const [data, setData] = useState({
    list: '',
    load: false,
  });
  useEffect(() => {
    setData((data) => ({ ...data, load: true }));
    apis.activityPlanLevel({ version, planCode }).then((res) => {
      if (res.ret === '0' && res.data) {
        setData({
          list: res.data.list,
          load: false,
        });
      }
    });
  }, [version, planCode]);

  return (
    <Select
      allowClear
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) => option.children.indexOf(input) >= 0}
      placeholder="请选择"
      {...props}
    >
      {data.list &&
        data.list.map((item) => (
          <Option key={item.val} value={item.val}>
            {item.title}
          </Option>
        ))}
    </Select>
  );
}

export default SelectActivityLevel;
